module.exports = __webpack_public_path__ + "img/iconography-0.25925d62.jpg";